import { NgModule } from '@angular/core';
import { FormlyMatFormFieldModule } from '@ngx-formly/material/form-field';
import * as ɵngcc0 from '@angular/core';
export { FieldType } from '@ngx-formly/material/form-field';
import { FormlyMatInputModule } from '@ngx-formly/material/input';
import { FormlyMatTextAreaModule } from '@ngx-formly/material/textarea';
import { FormlyMatRadioModule } from '@ngx-formly/material/radio';
import { FormlyMatCheckboxModule } from '@ngx-formly/material/checkbox';
import { FormlyMatMultiCheckboxModule } from '@ngx-formly/material/multicheckbox';
import { FormlyMatSelectModule } from '@ngx-formly/material/select';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class FormlyMaterialModule {
}
FormlyMaterialModule.ɵfac = function FormlyMaterialModule_Factory(t) { return new (t || FormlyMaterialModule)(); };
FormlyMaterialModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: FormlyMaterialModule });
FormlyMaterialModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [FormlyMatFormFieldModule,
        FormlyMatInputModule,
        FormlyMatTextAreaModule,
        FormlyMatRadioModule,
        FormlyMatCheckboxModule,
        FormlyMatMultiCheckboxModule,
        FormlyMatSelectModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(FormlyMaterialModule, [{
        type: NgModule,
        args: [{
                imports: [
                    FormlyMatFormFieldModule,
                    FormlyMatInputModule,
                    FormlyMatTextAreaModule,
                    FormlyMatRadioModule,
                    FormlyMatCheckboxModule,
                    FormlyMatMultiCheckboxModule,
                    FormlyMatSelectModule,
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(FormlyMaterialModule, { imports: function () { return [FormlyMatFormFieldModule,
        FormlyMatInputModule,
        FormlyMatTextAreaModule,
        FormlyMatRadioModule,
        FormlyMatCheckboxModule,
        FormlyMatMultiCheckboxModule,
        FormlyMatSelectModule]; } }); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { FormlyMaterialModule };

